<script>
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import Pagination from "@/components/Pagination.vue";
import http from "../../helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import PlanModal from "@/views/plan/PlanModal.vue";
import SurveyModal from "@/views/survey/SurveyModal.vue";
import SurveySettingModal from "@/views/survey/SurveySettingModal.vue";
import SurveyQuestionModal from "@/views/survey/SurveyQuestionModal.vue";

export default {
  name: "SurveyList",
  components: {
    SurveyQuestionModal,
    SurveySettingModal,
    SurveyModal,
    PlanModal,
    Pagination,
    Toolbar,
  },
  data() {
    return {
      search: '',
      modalKey: Date.now().toString(),
      selectedSurvey: null,
      surveys: [],
    }
  },
  mounted() {
    this.resetPage();
    this.fetchSurveys();
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    fetchSurveys() {
      this.surveys = [];
      http.get(`/places/${this.place.id_place}/surveys`, {
        params: {
          'page': this.$route.query.page,
          'search': this.search,
          'per_page': 10,
        }
      }).then((response) => {
        this.surveys = response.data;
      });
    },
    showModalSettings() {
      Modal.toggle('#modalSurveySettings');
    },
    newSurvey() {
      this.selectedSurvey = null;
      this.modalKey = Date.now().toString();

      Modal.toggle('#surveyModal');
    },
    editSurvey(survey) {
      this.selectedSurvey = survey;

      Modal.toggle('#surveyModal');
    },
    showSurveyQuestions(survey) {
      this.selectedSurvey = survey;

      Modal.toggle('#modalSurveyQuestions');
    },
    deleteSurvey(survey) {
      Swal.fire({
        title: 'Atenção',
        text: "Tem certeza que deseja remover a pesquisa?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/surveys/${survey.id_survey}`).then(() => {
            this.fetchSurveys();
          }).catch((e) => {
            Alert.error(e.response.data);
          });
        }
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    }
  }
}
</script>

<template>
  <Toolbar classes="pt-3">

    <template v-slot:actions>
      <div class="d-flex align-items-center flex-wrap">
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-sm btn-primary" title="Configurar" @click="showModalSettings">
              Configurar
            </button>
          </div>
        </div>
      </div>

      <SurveySettingModal/>
    </template>
  </Toolbar>

  <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none">
                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                          transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                    <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="black"></path>
                  </svg>
              </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar...">
          </div>
        </div>
        <div class="card-toolbar">
          <button class="btn btn-primary" @click="newSurvey">
            Nova Pesquisa
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Título</th>
              <th>Tipo de pesquisa</th>
              <th>Especialidade</th>
              <th>Status</th>
              <th class="text-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="survey in surveys.data">
              <td class="d-flex align-items-center">
                <div class="d-flex flex-column">
                  <span class="text-gray-800 text-hover-primary mb-1">{{ survey.survey_title }}</span>
                  <span>{{ survey.survey_description }}</span>
                </div>
              </td>
              <td>{{ survey.survey_type_dsc }}</td>
              <td>{{ survey.specialty?.spec_name }}</td>
              <td>{{ survey.survey_active ? 'Sim' : 'Não' }}</td>
              <td class="text-center" style="min-width: 125px;">
                <router-link
                  class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                  :to="'/surveys/' + survey.id_survey"
                  title="Respostas da pesquisa">
                  <i class="bi bi-list-stars"></i>
                </router-link>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="editSurvey(survey)"
                        title="Editar pesquisa">
                  <i class="bi bi-pen"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="showSurveyQuestions(survey)"
                        title="Gerenciar perguntas">
                  <i class="bi bi-question-circle"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" @click="deleteSurvey(survey)"
                        title="Apagar pesquisa">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <Pagination :data="surveys"/>
        </div>
      </div>
    </div>

    <SurveyModal
      :survey="selectedSurvey"
      @onClose="selectedSurvey = null"
      @surveySaved="fetchSurveys()"
    />

    <SurveyQuestionModal
      :survey="selectedSurvey"
      @onClose="selectedSurvey = null"
    />
  </div>
</template>

<style scoped>

</style>